// src/pages/SeleccionarNivel.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../config.js';
import './SeleccionarNivel.css';
import fondo from '../assets//img_generales/fondo.png';

const SeleccionarNivel = () => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState('');
  const [cargandoEstado, setCargandoEstado] = useState(true);

  const [cumplioRepaso, setCumplioRepaso] = useState(false);
  const [cumplioBasico, setCumplioBasico] = useState(false);
  const [cumplioMedio, setCumplioMedio] = useState(false);
  const [cumplioAvanzado, setCumplioAvanzado] = useState(false);

  useEffect(() => {
    const u = localStorage.getItem('usuario') || '';
    setUsuario(u);

    if (!u) {
      setCargandoEstado(false);
      return;
    }

    const url = `${API_URL}/estado-niveles?nombreUsuario=${encodeURIComponent(u)}`;

    fetch(url, { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('resp_invalida'))))
      .then((data) => {
        if (data && data.ok) {
          setCumplioRepaso(Boolean(data.repaso));
          setCumplioBasico(Boolean(data.basico));
          setCumplioMedio(Boolean(data.medio));
          setCumplioAvanzado(Boolean(data.avanzado));
        }
      })
      .catch((error) => {
        console.error('❌ Error consultando estado de niveles:', error);
        setCumplioRepaso(false);
        setCumplioBasico(false);
        setCumplioMedio(false);
        setCumplioAvanzado(false);
      })
      .finally(() => {
        setCargandoEstado(false);
      });
  }, []);

  const puedeNivelMedio = cumplioBasico;
  const puedeNivelAvanzado = cumplioBasico && cumplioMedio;

  const seleccionarNivel = (nivel) => {
    if (nivel === 'Nivel Repaso') {
      navigate('/nivel-repaso');
      return;
    }

    if (nivel === 'Mañana Tranquila') {
      navigate('/nivel-basico');
      return;
    }

    if (nivel === 'Tarde de Miedo') {
      if (!puedeNivelMedio) {
        alert('🔒 Debes finalizar el nivel Mañana Tranquila antes de ingresar a Tarde de Miedo.');
        return;
      }

      navigate('/nivel-medio');
      return;
    }

    if (nivel === 'Noche de Caos') {
      if (!puedeNivelAvanzado) {
        alert('🔒 Debes finalizar Mañana Tranquila y Tarde de Miedo antes de ingresar a Noche de Caos.');
        return;
      }

      navigate('/nivel-avanzado');
      return;
    }
  };

  return (
    <div className="pantalla-niveles" style={{ backgroundImage: `url(${fondo})` }}>
      <div className="logout-container">
        <button
          className="btn-logout-nivel"
          onClick={() => {
            localStorage.removeItem('usuario');
            navigate('/');
          }}
        >
          🔒 Logout
        </button>
      </div>

      <div className="contenedor-niveles">
        <h2>Bienvenido a Turno24 RX</h2>
        <h3>Selecciona el Nivel del turno en el que quieres ingresar</h3>

        {cargandoEstado && (
          <p className="estado-cargando">⏳ Verificando progreso...</p>
        )}

        <button
          className={`btn-nivel repaso ${cumplioRepaso ? 'completado' : ''}`}
          onClick={() => seleccionarNivel('Nivel Repaso')}
          disabled={cargandoEstado}
        >
          <span>📝 Nivel Repaso</span>
          {cumplioRepaso && <span className="medalla" title="Repaso aprobado!">🏅</span>}
        </button>

        <button
          className={`btn-nivel mañana ${cumplioBasico ? 'completado' : ''}`}
          onClick={() => seleccionarNivel('Mañana Tranquila')}
          disabled={cargandoEstado}
        >
          <span>🌅 Mañana Tranquila</span>
          {cumplioBasico && <span className="medalla" title="Nivel Básico aprobado!">🏅</span>}
        </button>

        <button
          className={`btn-nivel tarde ${!puedeNivelMedio ? 'bloqueado' : ''} ${cumplioMedio ? 'completado' : ''}`}
          onClick={() => seleccionarNivel('Tarde de Miedo')}
          disabled={cargandoEstado}
        >
          <span>🌇 Tarde de Miedo</span>
          {cumplioMedio ? (
            <span className="medalla" title="Nivel Medio aprobado!">🏅</span>
          ) : !puedeNivelMedio ? (
            <span className="candado" title="Completa Mañana Tranquila para desbloquear">🔒</span>
          ) : (
            <span className="desbloqueado" title="Nivel desbloqueado"></span>
          )}
        </button>

        <button
          className={`btn-nivel noche ${!puedeNivelAvanzado ? 'bloqueado' : ''} ${cumplioAvanzado ? 'completado' : ''}`}
          onClick={() => seleccionarNivel('Noche de Caos')}
          disabled={cargandoEstado}
        >
          <span>🌃 Noche de Caos</span>
          {cumplioAvanzado ? (
            <span className="medalla" title="Nivel Avanzado aprobado!">🏅</span>
          ) : !puedeNivelAvanzado ? (
            <span className="candado" title="Completa los niveles anteriores para desbloquear">🔒</span>
          ) : (
            <span className="desbloqueado" title="Nivel desbloqueado"></span>
          )}
        </button>
      </div>
    </div>
  );
};

export default SeleccionarNivel;